var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssessment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M5.3335 25.3334V6.66675C5.3335 4.45741 7.12416 2.66675 9.3335 2.66675H18.6668L26.6668 10.6667V25.3334C26.6668 27.5427 24.8762 29.3334 22.6668 29.3334H9.3335C7.12416 29.3334 5.3335 27.5427 5.3335 25.3334Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 8.00008V2.66675L26.6665 10.6667H21.3332C19.8598 10.6667 18.6665 9.47341 18.6665 8.00008Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8384 22.3359L13.5758 21.1693H10.8758L10.6131 22.3359C10.4784 22.9346 9.94645 23.3599 9.33312 23.3599C8.48245 23.3599 7.85712 22.5639 8.05845 21.7386L10.1838 12.9906C10.4211 12.0186 11.2918 11.3333 12.2931 11.3333C13.2958 11.3333 14.1664 12.0199 14.4024 12.9933L16.5144 21.7399C16.7144 22.5653 16.0878 23.3599 15.2384 23.3599H15.1184C14.5051 23.3599 13.9731 22.9346 13.8384 22.3359ZM12.2678 13.9493H12.1998L11.1811 19.0613H13.2358L12.2678 13.9493Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 18.6667H18.6668C17.9308 18.6667 17.3335 18.0693 17.3335 17.3333C17.3335 16.5973 17.9308 16 18.6668 16H24.0002C24.7362 16 25.3335 16.5973 25.3335 17.3333C25.3335 18.0693 24.7362 18.6667 24.0002 18.6667Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 21.3333C20.5973 21.3333 20 20.7359 20 19.9999V14.6666C20 13.9306 20.5973 13.3333 21.3333 13.3333C22.0693 13.3333 22.6667 13.9306 22.6667 14.6666V19.9999C22.6667 20.7359 22.0693 21.3333 21.3333 21.3333Z",
    fill: "black",
    fillOpacity: 0.95
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.1279e0f4b9ed29820e066b5095d79b09.svg";
export { ForwardRef as ReactComponent };